import yup from '~/utils/validators.yup';

export const cardTransformedDetailRule = {
    cardTransformedDetail: yup.object().shape({
        playerTransformedActionOrUpgradeCard: yup.mixed(),
        opponentTransformedActionOrUpgradeCard: yup.mixed(),
        inDeckTransformedCard: yup.mixed(),
    }),
};
